/**
 * UUID generation utilities
 */

/**
 * Generates a UUID v4 using the browser's crypto API when available,
 * falling back to a polyfill for older browsers
 *
 * @returns {string} A UUID v4 string
 */
export const generateUUID = () => {
  // Use native crypto.randomUUID() if available (modern browsers, secure contexts)
  if (typeof crypto !== 'undefined' && crypto.randomUUID) {
    return crypto.randomUUID();
  }

  // Fallback implementation for older browsers
  // from https://github.com/RedVentures/beam/blob/main/src/utils/uuid.js
  // (which comes from https://stackoverflow.com/questions/105034/how-to-create-guid-uuid/2117523#2117523)
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (char) => {
    const rand = (Math.random() * 16) | 0;
    const val = char === 'x' ? rand : (rand & 0x3) | 0x8;
    return val.toString(16);
  });
};
